'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serialize = serialize;
exports.deserialize = deserialize;

var _omit = require('transmute/omit');

var _omit2 = _interopRequireDefault(_omit);

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _messageTypes = require('../pubnub-message/constants/messageTypes');

var _buildPublishedMessage = require('../factories/PubNubMessageFactory/buildPublishedMessage');

var _commentMessageToPubNubMessage = require('../pubnub-message/operators/commentMessageToPubNubMessage');

var _MessageDescriptorSources = require('../constants/MessageDescriptorSources');

var _commonMessageFormatGetters = require('../common-message-format/operators/commonMessageFormatGetters');

var _pubnubMessageSetters = require('../pubnub-message/operators/pubnubMessageSetters');

var _isThreadComment = require('../pubnub-message/operators/isThreadComment');

var _isCommonMessageFormat = require('../common-message-format/operators/isCommonMessageFormat');

var _CommentToJson = require('../pubnub-message/operators/CommentToJson');

var _MessageToJson = require('../pubnub-message/operators/MessageToJson');

var _buildCommonMessage = require('../common-message-format/operators/buildCommonMessage');

var _CrmObjectLifecycleUpdate = require('../crm-object-lifecycle-update/records/CrmObjectLifecycleUpdate');

var _CrmObjectLifecycleUpdate2 = _interopRequireDefault(_CrmObjectLifecycleUpdate);

var _isCrmObjectLifecycleUpdate = require('../crm-object-lifecycle-update/operators/isCrmObjectLifecycleUpdate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TOP_LEVEL_KEYS = ['client', 'clientTs', 'id', 'senderId', 'threadId', 'timestamp'];

function serialize(message) {
  if ((0, _isCommonMessageFormat.isCommonMessageFormat)(message)) {
    return message.toJS();
  }

  switch ((0, _commonMessageFormatGetters.getType)(message)) {
    case _messageTypes.THREAD_COMMENT:
      return (0, _CommentToJson.commentToJson)(message);
    default:
      return (0, _MessageToJson.messageToJson)(message);
  }
}

function constructMessage(_ref) {
  var json = _ref.json,
      channel = _ref.channel,
      timetoken = _ref.timetoken,
      factoryFn = _ref.factoryFn;

  return (0, _pipe2.default)(factoryFn, (0, _pubnubMessageSetters.setChannel)(channel), (0, _pubnubMessageSetters.setSource)(_MessageDescriptorSources.MESSAGE_LISTENER), (0, _pubnubMessageSetters.setTimetoken)(timetoken))(json);
}

function deserialize(_ref2) {
  var json = _ref2.json,
      channel = _ref2.channel,
      timetoken = _ref2.timetoken,
      _ref2$factoryFn = _ref2.factoryFn,
      factoryFn = _ref2$factoryFn === undefined ? _buildPublishedMessage.buildPublishedMessage : _ref2$factoryFn;

  if ((0, _isThreadComment.isThreadComment)(json)) {
    json = (0, _commentMessageToPubNubMessage.commentMessageToPubNubMessage)(json);
  }

  if ((0, _isCommonMessageFormat.isCommonMessageFormat)(json)) {
    return (0, _buildCommonMessage.buildCommonMessage)(json);
  }

  if ((0, _isCrmObjectLifecycleUpdate.isCrmObjectLifecycleUpdate)(json)) {
    return new _CrmObjectLifecycleUpdate2.default(json);
  }

  if ((0, _commonMessageFormatGetters.getType)(json)) {
    return constructMessage({ json: json, channel: channel, timetoken: timetoken, factoryFn: factoryFn });
  }

  // Convert V1 message to V2 to maintain compatibility with older clients
  var metadata = (0, _omit2.default)(TOP_LEVEL_KEYS, json);

  json.metadata = metadata;
  json.metadata.welcomeMessageId = metadata.messageId;
  json.metadata[_messageTypes.MESSAGE_TYPE_ID] = metadata.type;

  return constructMessage({ json: json, channel: channel, timetoken: timetoken, factoryFn: factoryFn });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/serializers/PubNubMessageSerializer.js
// module id = 321
// module chunks = 2 3